function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/setPrototypeOf.js
// module id = 361
// module chunks = 0